import { type ChangeEvent, useRef } from 'react'
import { Checkbox, CheckboxProps } from '@dhl-ui/components'
import { WithRequired } from './types'
import { FormikHandlers, useFormikContext, useField } from './shared'

export type CheckboxInputProps = WithRequired<CheckboxProps, 'name'> & {
  validateOnChange?: boolean
  onBlur?: FormikHandlers['handleBlur']
}

/** @deprecated: move towards react-hook-form */
export const CheckboxInput = ({ name, validateOnChange, onBlur, disabled, ...props }: CheckboxInputProps) => {
  const [field, meta, helpers] = useField<boolean>(name)
  const { isSubmitting, validateOnChange: formValidateOnChange } = useFormikContext()
  const inputRef = useRef<HTMLInputElement | null>(null)

  const onChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    helpers.setValue(checked, formValidateOnChange || validateOnChange)
  }

  return (
    <Checkbox
      {...props}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      checked={!!field.value}
      disabled={isSubmitting || disabled}
      error={!!meta.error && meta.touched}
      helperText={meta.touched && meta.error?.trim() ? meta.error : props.helperText}
      slotProps={{
        ...props.slotProps,
        input: {
          ...props.slotProps?.input,
          ref: inputRef,
        },
      }}
    />
  )
}
